module.exports = __webpack_public_path__ + "img/atlanta_map.png";